import { FunctionalComponent, h } from 'preact';
import { styled } from 'linaria/react';

export const Modal: FunctionalComponent<{className?: string, contentClassName?: string}> = (props) => {
	const {children, className, contentClassName} = props;

    return (
        <ModalContainer className={className}>
	        <div className={contentClassName}>
		        {children}
	        </div>
        </ModalContainer>
    )
};

const ModalContainer = styled('div')`
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: rgba(0,0,0,0.7);
  z-index: 1000000000000;
`;
